import type {Part} from 'schemaDefinition/types';
import {getCustomValidator} from '../functions/validators';

export const useCustomValidator = (part: Part) => getCustomValidator(part);
